import boardListController from '__core/client/controller/Tickets';
import Ticket from '__core/shared/model/ticket/Ticket';
import { TicketStatusType } from '__core/shared/model/ticket/Ticket.enum';
import TicketAssetFinance from '__core/shared/model/ticket/TicketAssetFinance';
import TicketCommercialLoan from '__core/shared/model/ticket/TicketCommercialLoan';
import TicketCommercialLoanSecuritySplit from '__core/shared/model/ticket/TicketCommercialLoanSecuritySplit';
import { TicketCommercialLoanSecuritySplitType } from '__core/shared/model/ticket/TicketCommercialLoanSecuritySplit.enum';
import TicketContactType from '__core/shared/model/ticket/TicketContactType';
import TicketConveyancingLoan from '__core/shared/model/ticket/TicketConveyancingLoan';
import TicketHomeLoan from '__core/shared/model/ticket/TicketHomeLoan';
import TicketInsurance from '__core/shared/model/ticket/TicketInsurance';
import TicketLoanDetailsSplit from '__core/shared/model/ticket/TicketLoanDetailsSplit';
import TicketLoanFee from '__core/shared/model/ticket/TicketLoanFee';
import { TicketLoanFeeType } from '__core/shared/model/ticket/TicketLoanFee.enum';
import TicketLoanPropertySplit from '__core/shared/model/ticket/TicketLoanPropertySplit';
import TicketLoanSecuritySplit from '__core/shared/model/ticket/TicketLoanSecuritySplit';
import TicketOpenBanking from '__core/shared/model/ticket/TicketOpenBanking';
import TicketPersonalLoan from '__core/shared/model/ticket/TicketPersonalLoan';
import { TicketPersonalLoanPurpose } from '__core/shared/model/ticket/TicketPersonalLoanPurpose.enum';
import TicketProjectHistory from '__core/shared/model/ticket/TicketProjectHistory';
import TicketRealEstate from '__core/shared/model/ticket/TicketRealEstate';
import TicketSharedWithClientProfile from '__core/shared/model/ticket/TicketSharedWithClientProfile';
import { TicketSharedWithClientProfileType } from '__core/shared/model/ticket/TicketSharedWithClientProfile.enum';
import TicketSharedWithClientProfileSection from '__core/shared/model/ticket/TicketSharedWithClientProfileSection';
import TicketStageHistory from '__core/shared/model/ticket/TicketStageHistory';
import TicketStatusHistory from '__core/shared/model/ticket/TicketStatusHistory';
import TicketTitleDetail from '__core/shared/model/ticket/TicketTitleDetail';
import boardController from './board.controller';
import boardService from './board.service';
import stFeesAndCharges from './feesAndCharges.component';
import feesAndChargesController from './feesAndCharges.controller';
import listController from './list.controller';
import TicketDataList from './list.factory';
import projectController from './project.controller';
import projectService from './project.service';
import stStatusSelectDialog from './statusSelectDialog.component';
import stTicketActivityList from './ticketActivityList.component';
import stTicketAssetFinance from './ticketAssetFinance.component';
import stTicketCommercialLoan from './ticketCommercialLoan.component';
import stTicketContactEdit from './ticketContactEdit.component';
import stTicketConveyancing from './ticketConveyancing.component';
import ticketEditController from './ticketEdit.controller';
import ticketFactFindService from './ticketFactFind.service';
import stTicketHomeLoan from './ticketHomeLoan.component';
import stTicketInsurance from './ticketInsurance.component';
import templateTicketMoveToAnotherWorkflow from './ticketMoveToAnotherWorkflow.template.html';
import stTicketPersonalLoan from './ticketPersonalLoan.component';
import stTicketProjectStatus from './ticketProjectStatus.component';
import stTicketProjectStatusPicker from './ticketProjectStatusPicker.directive';
import stTicketRealEstate from './ticketRealEstate.component';
import stTicketsFilter from './ticketsFilter.component';
import templateTicketStatusChange from './ticketStatusChange.template.html';
import stTicketTile from './ticketTile.component';
import stTicketTileActions from './ticketTileActions.directive';
import ticketViewController from './ticketView.controller';
import stTicketViewContactAdd from './ticketViewContactAdd.component';
import stTicketViewImportantList from './ticketViewImportantList.component';
import stTicketViewList from './ticketViewList.component';

export default angular
  .module('st.Ticket', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .factory('Ticket', () => Ticket)
  .factory('TicketContactType', () => TicketContactType)
  .factory('TicketStatusType', () => TicketStatusType)
  .factory('TicketAssetFinance', () => TicketAssetFinance)
  .factory('TicketInsurance', () => TicketInsurance)
  .factory('TicketHomeLoan', () => TicketHomeLoan)
  .factory('TicketCommercialLoan', () => TicketCommercialLoan)
  .factory('TicketCommercialLoanSecuritySplit', () => TicketCommercialLoanSecuritySplit)
  .factory('TicketCommercialLoanSecuritySplitType', () => TicketCommercialLoanSecuritySplitType)
  .factory('TicketPersonalLoan', () => TicketPersonalLoan)
  .factory('TicketConveyancingLoan', () => TicketConveyancingLoan)
  .factory('TicketRealEstate', () => TicketRealEstate)
  .factory('TicketPersonalLoanPurpose', () => TicketPersonalLoanPurpose)
  .factory('TicketProjectHistory', () => TicketProjectHistory)
  .factory('TicketStageHistory', () => TicketStageHistory)
  .factory('TicketStatusHistory', () => TicketStatusHistory)
  .factory('TicketLoanDetailsSplit', () => TicketLoanDetailsSplit)
  .factory('TicketLoanSecuritySplit', () => TicketLoanSecuritySplit)
  .factory('TicketLoanFee', () => TicketLoanFee)
  .factory('TicketTitleDetail', () => TicketTitleDetail)
  .factory('TicketLoanFeeType', () => TicketLoanFeeType)
  .factory('TicketLoanPropertySplit', () => TicketLoanPropertySplit)
  .factory('TicketSharedWithClientProfile', () => TicketSharedWithClientProfile)
  .factory('TicketSharedWithClientProfileSection', () => TicketSharedWithClientProfileSection)
  .factory('TicketSharedWithClientProfileType', () => TicketSharedWithClientProfileType)
  .factory('TicketOpenBanking', () => TicketOpenBanking)
  .factory('TicketDataList', TicketDataList)
  .directive('stTicketTileActions', stTicketTileActions)
  .component('stTicketViewContactAdd', stTicketViewContactAdd)
  .component('stTicketViewImportantList', stTicketViewImportantList)
  .component('stTicketViewList', stTicketViewList)
  .controller('ticketViewController', ticketViewController)
  .component('stTicketTile', stTicketTile)
  .component('stTicketsFilter', stTicketsFilter)
  .component('stTicketRealEstate', stTicketRealEstate)
  .directive('stTicketProjectStatusPicker', stTicketProjectStatusPicker)
  .component('stTicketProjectStatus', stTicketProjectStatus)
  .component('stTicketPersonalLoan', stTicketPersonalLoan)
  .component('stTicketInsurance', stTicketInsurance)
  .component('stTicketHomeLoan', stTicketHomeLoan)
  .service('ticketFactFindService', ticketFactFindService)
  .controller('ticketEditController', ticketEditController)
  .component('stTicketConveyancing', stTicketConveyancing)
  .component('stTicketCommercialLoan', stTicketCommercialLoan)
  .component('stTicketAssetFinance', stTicketAssetFinance)
  .component('stTicketActivityList', stTicketActivityList)
  .component('stTicketContactEdit', stTicketContactEdit)
  .service('projectService', projectService)
  .controller('projectController', projectController)
  .controller('listController', listController)
  .service('boardService', boardService)
  .controller('boardController', boardController)
  .controller('boardListController', boardListController)
  .controller('feesAndChargesController', feesAndChargesController)
  .component('stFeesAndCharges', stFeesAndCharges)
  .component('stStatusSelectDialog', stStatusSelectDialog)
  .service(
    'ticketService',
    (
      $http,
      $q,
      $rootScope,
      dataService,
      $mdDialog,
      accountService,
      accountsService,
      notesService,
      lendersService,
      helperService,
      TicketStatusHistory,
      uiService,
      Ticket,
      AssetFinance,
      HomeLoan,
      TICKET,
      ACCOUNT
    ) => {
      const fieldsDifference = (availableFields, ticketFields) => {
        const missingFields = _.difference(
          _.map(availableFields, 'id'),
          _.map(ticketFields, 'id')
        );
        if (missingFields && missingFields.length) {
          return ticketFields.concat(
            availableFields.filter((f) => missingFields.indexOf(f.id) > -1)
          );
        }
        return ticketFields;
      };
      const isFieldExist = (availableFields, idField) =>
        _.find(availableFields, (f) => f.id === idField);
      const canSeeDue = (ticket) => !ticket.isSettled && !ticket.isLost && !ticket.isWon;
      const getStatusByFinanceDueDate = (ticket) => {
        let isFinanceDueDateOverdue = false;
        let isFinanceDueDateReached = false;
        let isFinanceDueDateAhead = false;
        if (ticket?.values?.financeDueDate) {
          const dateNow = moment.utc().startOf('day');
          const dateTomorrow = moment.utc().startOf('day').add(1, 'day');
          const dateDue = moment.utc(ticket.values.financeDueDate, 'X').startOf('day');
          isFinanceDueDateOverdue = dateDue.isBefore(dateNow, 'day');
          isFinanceDueDateReached = dateDue.isSame(dateNow, 'day');
          isFinanceDueDateAhead = dateDue.isSame(dateTomorrow, 'day');
        }

        return { isFinanceDueDateOverdue, isFinanceDueDateReached, isFinanceDueDateAhead };
      };
      const getTicketStatus = (ticket, showFinanceDueDate) => {
        const statusByFinanceDueDate = getStatusByFinanceDueDate(ticket);
        let output = '';
        if (!showFinanceDueDate && ticket?.isDueAhead) {
          output = ' due tomorrow ';
        }
        if (!showFinanceDueDate && ticket?.isDue) {
          output = ' due ';
        }
        if (!showFinanceDueDate && ticket?.isOverdue) {
          output = ' overdue ';
        }
        if (
          showFinanceDueDate &&
          (ticket?.isFinanceDueDateAhead || statusByFinanceDueDate?.isFinanceDueDateAhead)
        ) {
          output = ' due tomorrow ';
        }
        if (
          showFinanceDueDate &&
          (ticket?.isFinanceDueDateReached || statusByFinanceDueDate?.isFinanceDueDateReached)
        ) {
          output = ' due ';
        }
        if (
          showFinanceDueDate &&
          (ticket?.isFinanceDueDateOverdue || statusByFinanceDueDate?.isFinanceDueDateOverdue)
        ) {
          output = ' overdue ';
        }
        if (ticket?.isWon) {
          output = ' won ';
        }
        if (ticket?.isLost) {
          output = ' lost ';
        }
        if (ticket?.isFrozen) {
          output = ' paused ';
        }
        if (ticket?.isRotten) {
          output = ' stale ';
        }
        if (ticket?.isLodged) {
          output = ' lodged ';
        }
        if (ticket?.isSubmitted) {
          output = ' submitted ';
        }
        if (ticket?.isWithDrawn) {
          output = ' withdrawn ';
        }
        if (ticket?.isDeclined) {
          output = ' declined ';
        }
        if (ticket?.isConditionallyApproved) {
          output = ' conditionally approved ';
        }
        if (ticket?.isApproved) {
          output = ' approved ';
        }
        if (ticket?.isSettled) {
          output = ' settled ';
        }
        return output;
      };
      const setCaretClass = (isView) => (isView ? 'down' : 'up');
      const setTicketClass = (ticket, showFinanceDueDate) => {
        const statusByFinanceDueDate = getStatusByFinanceDueDate(ticket);
        let output = '';
        if (ticket.isActive) {
          const canSetDue = canSeeDue(ticket);

          if (!showFinanceDueDate && ticket?.isDueAhead && canSetDue) {
            output += ' dueahead ';
          }
          if (!showFinanceDueDate && ticket?.isDue && canSetDue) {
            output += ' due ';
          }
          if (!showFinanceDueDate && ticket?.isOverdue && canSetDue) {
            output += ' overdue ';
          }
          if (
            showFinanceDueDate &&
            (ticket?.isFinanceDueDateAhead || statusByFinanceDueDate?.isFinanceDueDateAhead) &&
            canSetDue
          ) {
            output += ' dueahead ';
          }
          if (
            showFinanceDueDate &&
            (ticket?.isFinanceDueDateReached ||
              statusByFinanceDueDate?.isFinanceDueDateReached) &&
            canSetDue
          ) {
            output += ' due ';
          }
          if (
            showFinanceDueDate &&
            (ticket?.isFinanceDueDateOverdue ||
              statusByFinanceDueDate?.isFinanceDueDateOverdue) &&
            canSetDue
          ) {
            output += ' overdue ';
          }
          if (ticket?.isFrozen) {
            output += ' frozen ';
          }
          if (ticket?.isLost) {
            output += ' lost ';
          }
          if (ticket?.isWon) {
            output += ' won ';
          }
          if (ticket?.isRotten) {
            output += ' stale ';
          }
          if (ticket?.isSettled) {
            output += ' settled ';
          }
        } else {
          output += ' deleted ';
        }
        return output;
      };
      const getAttachments = async (ticket) => {
        const notes = await notesService.getSpecific({
          idTickets: ticket.id,
          isActive: true
        });

        let noteAttachments = notes.map((note) => {
          const attachments = [];
          if (note.attachments.length > 0) {
            for (let a = 0; a < note.attachments.length; a += 1) {
              const attach = note.attachments[a];
              attach.idNote = note.id;
              attach.noteType = note.type;
              if (_.find(attachments, (s) => s.id === attach.id) === undefined) {
                attachments.push(attach);
              }
            }
            return attachments;
          }
          return attachments;
        });

        noteAttachments = _.flatten(noteAttachments);

        return _.union(ticket.attachments, noteAttachments);
      };
      const ticketMoveToAnotherWorkflow = ({
        event,
        ticket,
        workflow,
        workflows,
        accounts,
        isDuplicated
      }) => {
        const deferred = $q.defer();
        event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: event,
            locals: {
              ticket: angular.copy(ticket),
              idWorkflowPrev: ticket.idWorkflow || '',
              workflow: workflow || {},
              workflows: workflows || [],
              accounts: accounts || [],
              isDuplicated: isDuplicated || false
            },
            template: templateTicketMoveToAnotherWorkflow,
            controllerAs: '$ctrl',
            controller(ticket, idWorkflowPrev, workflow, workflows, accounts, isDuplicated) {
              const ctrl = this;
              ctrl.ticket = ticket;
              ctrl.idWorkflowPrev = idWorkflowPrev;
              ctrl.workflow = workflow;
              ctrl.workflows = workflows;
              ctrl.accounts = accounts;
              ctrl.isDuplicated = isDuplicated;

              ctrl.currentTicketOwner = _.find(
                ctrl.accounts,
                (a) => a?.id === ctrl.ticket.idOwner
              );
              ctrl.workflowType = ctrl.workflow?.type?.name || ctrl.workflow?.type;
              if (!ctrl.isDuplicated && !ctrl.workflow.isNoType()) {
                ctrl.workflows = _.filter(
                  ctrl.workflows,
                  (w) => w?.type?.name === ctrl.workflowType || w?.type === ctrl.workflowType
                );
              }

              ctrl.lenders = [];
              ctrl.loanToCreate = null;
              ctrl.showInfo = false;
              ctrl.isProcessing = false;
              ctrl.getWorkflow = (idWorkflow) =>
                ctrl.workflows.find((w) => w.id === idWorkflow);
              ctrl.changeWorkflow = (idWorkflow) => {
                ctrl.isProcessing = true;
                const idAccounts = _.compact(
                  ctrl
                    .getWorkflow(idWorkflow)
                    .idTeamMembers.concat(ctrl.getWorkflow(idWorkflow).idOwner)
                );
                accountsService
                  .getSpecific({
                    ids: idAccounts,
                    isActive: true,
                    fields: ACCOUNT.FIELDS.LIST
                  })
                  .then((results) => {
                    if (results && results.length) {
                      ctrl.accounts = results;
                      ctrl.ticket.idStage = ctrl.getWorkflow(idWorkflow).stages[0].id;
                      ctrl.workflow = ctrl.getWorkflow(idWorkflow);
                      ctrl.changeOwner(
                        ctrl.isDuplicated ? ctrl.ticket?.idOwner : ctrl.currentTicketOwner?.id
                      );
                    }
                  });
              };
              ctrl.changeOwner = (idOwner) => {
                ctrl.loanToCreate = null;
                ctrl.isProcessing = true;
                ctrl.showInfo = false;
                accountService.readAccount({ id: idOwner }).then((account) => {
                  const newTicketOwner = account;
                  ctrl.ticket.idOwner = newTicketOwner?.id || '';
                  if (newTicketOwner && ctrl.isDuplicated) {
                    let lenderType;
                    if (ctrl.workflow.isHomeLoan()) {
                      lenderType = 'RESIDENTIAL';
                    } else if (ctrl.workflow.isAssetFinance()) {
                      lenderType = 'ASSET_FINANCE';
                    }
                    if (lenderType) {
                      lendersService
                        .getAvailable({
                          cca2: [helperService.getOrganizationCountry().cca2],
                          type: lenderType
                        })
                        .then((lenders) => {
                          if (lenders && lenders.length) {
                            const idLenders = _.compact(
                              newTicketOwner.lenderAccreditations.map((l) => l.idLender)
                            );
                            if (idLenders.length) {
                              ctrl.lenders = _.filter(
                                lenders,
                                (l) => idLenders.indexOf(l.id) > -1
                              );
                              if (ctrl.lenders?.length && ctrl.workflow?.isAssetFinance()) {
                                ctrl.loanToCreate = AssetFinance.blank();
                              } else if (ctrl.lenders?.length && ctrl.workflow?.isHomeLoan()) {
                                ctrl.loanToCreate = HomeLoan.blank();
                              } else {
                                ctrl.showInfo = true;
                              }
                            } else {
                              ctrl.showInfo = true;
                            }
                          }
                          ctrl.isProcessing = false;
                        });
                    } else {
                      ctrl.isProcessing = false;
                    }
                  } else {
                    ctrl.isProcessing = false;
                  }
                });
              };
              if (ctrl.workflow?.isAssetFinance() && ctrl.isDuplicated) {
                ctrl.changeOwner(ctrl.ticket?.idOwner);
              }
              ctrl.canSave = () =>
                ctrl.ticket && ctrl.ticket?.idWorkflow && ctrl.ticket?.idOwner;
              ctrl.confirm = () => {
                if (ctrl.canSave()) {
                  $mdDialog.hide({
                    idWorkflowPrev: ctrl.idWorkflowPrev,
                    ticket: ctrl.ticket,
                    loan: ctrl.loanToCreate,
                    isDuplicated: ctrl.isDuplicated,
                    ticketName: ctrl.ticket.name,
                    workflowName: ctrl.getWorkflow(ctrl.ticket.idWorkflow).getName()
                  });
                }
              };
              ctrl.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            const params = {
              idWorkflowPrev: result.idWorkflowPrev,
              ticket: result.ticket,
              loan: result.loan,
              isDuplicated: result.isDuplicated
            };
            dataService
              .apiRequest(
                null,
                null,
                null,
                null,
                $http.post,
                TICKET.API.MOVE_TO_ANOTHER_WORKFLOW,
                { params }
              )
              .then((res) => {
                const data = {
                  idTicket: res.idTicket,
                  idWorkflow: res.idWorkflow,
                  ticketName: result.ticketName,
                  workflowName: result.workflowName
                };
                deferred.resolve(data);
              });
          });
        return deferred.promise;
      };
      const ticketStatusChange = (status) => {
        const deferred = $q.defer();
        const statusHistoryBlank = TicketStatusHistory.blank();
        $mdDialog
          .show({
            targetEvent: null,
            locals: {
              statusToChange: status
            },
            template: templateTicketStatusChange,
            controllerAs: '$ctrl',
            controller(statusToChange) {
              const ctrl = this;
              ctrl.currentOrganization = $rootScope.CurrentOrganization;
              ctrl.currentCurrency = $rootScope.CurrentCurrency();
              ctrl.status = statusToChange || 'not verified';
              ctrl.statusHistory = statusHistoryBlank;
              ctrl.canSubmit = () => true;
              ctrl.confirm = () => {
                if (ctrl.statusHistory.note !== '') {
                  $mdDialog.hide({
                    status: ctrl.status,
                    statusHistory: ctrl.statusHistory
                  });
                } else {
                  uiService.toast({
                    text: {
                      p1: 'Deal',
                      p2: 'note',
                      p3: 'is required'
                    },
                    warn: true
                  });
                }
              };
              ctrl.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            const data = result;
            data.statusHistory.idOwner = $rootScope.CurrentAccount.id;

            switch (data.status) {
              case 'verification':
                data.statusHistory.isReadyForVerification = true;
                break;
              case 'verified':
                data.statusHistory.isReadyForVerification = true;
                data.statusHistory.isVerified = true;
                break;
              default:
                data.statusHistory.isReadyForVerification = false;
                data.statusHistory.isVerified = false;
                break;
            }
            deferred.resolve(data.statusHistory);
          });
        return deferred.promise;
      };
      return {
        fieldsDifference,
        isFieldExist,
        getTicketStatus,
        setCaretClass,
        setTicketClass,
        getAttachments,
        ticketMoveToAnotherWorkflow,
        ticketStatusChange,
        createTicket: (doc) => dataService.createDocument(Ticket, doc),
        readTicket: (doc) => dataService.readDocument(Ticket, doc),
        updateTicket: (doc) => {
          return dataService.updateDocument(Ticket, doc);
        },
        deleteTicket: (doc) => dataService.deleteDocument(Ticket, doc),
        editTicket: (params) =>
          dataService.apiRequest(null, null, null, null, $http.post, TICKET.API.EDIT, {
            params
          }),
        duplicateTicket: (params) =>
          dataService.apiRequest(null, null, null, null, $http.post, TICKET.API.DUPLICATE, {
            params
          }),
        updateContactFactFind: (params) =>
          dataService.apiRequest(
            null,
            null,
            null,
            null,
            $http.post,
            TICKET.API.CONTACT_UPDATE_FACT_FIND,
            { params }
          )
      };
    }
  )
  .service('ticketsService', ($http, $rootScope, CacheFactory, dataService, Ticket, TICKET) => {
    let cache;
    if (!CacheFactory.get(TICKET.CACHE.NAME)) {
      cache = CacheFactory(TICKET.CACHE.NAME, TICKET.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || TICKET.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getByEnterprise: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByEnterprise'),
          params?.ignoreCache === true,
          null,
          $http.get,
          TICKET.API.ENTERPRISE,
          { params }
        ),
      getByWorkflow: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByWorkflow'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.get,
          TICKET.API.WORKFLOW,
          { params }
        ),
      getByWorkflowAndStage: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByWorkflowAndStage'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.get,
          TICKET.API.WORKFLOW,
          { params }
        ),
      getByWorkflowAndStageCount: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByWorkflowAndStageCount'),
          params?.ignoreCache === true,
          null,
          $http.get,
          TICKET.API.WORKFLOW,
          { params }
        ),
      getByWorkflows: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByWorkflows'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.get,
          TICKET.API.WORKFLOWS,
          { params }
        ),
      getByContact: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByContact'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.get,
          TICKET.API.CONTACT,
          { params }
        ),
      getSpecific: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getSpecific'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.post,
          TICKET.API.SPECIFIC,
          { params }
        ),
      getTop: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getTop'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.post,
          TICKET.API.TOP,
          { params }
        ),
      getByWorkflowStage: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getByWorkflowStage'),
          params?.ignoreCache === true,
          Ticket.build,
          $http.get,
          TICKET.API.WORKFLOW_STAGE,
          { params }
        ),
      getCount: (params) =>
        dataService.apiRequest(null, null, null, null, $http.get, TICKET.API.COUNT, {
          params
        }),
      getShared: (params) =>
        dataService.apiRequest(null, null, null, null, $http.get, TICKET.API.SHARED, {
          params
        }),
      changeStage: (params) =>
        dataService.apiRequest(null, null, null, null, $http.post, TICKET.API.CHANGE_STAGE, {
          params
        })
    };
  })
  .constant('TICKET', {
    API: {
      ENTERPRISE: '/api/v1/tickets/enterprise/',
      WORKFLOW: '/api/v1/tickets/workflow/',
      WORKFLOWS: '/api/v1/tickets/workflows/',
      COUNT: '/api/v1/tickets/count/',
      SHARED: '/api/v1/tickets/shared/',
      CONTACT: '/api/v1/tickets/contact/',
      SPECIFIC: '/api/v1/tickets/specific/',
      TOP: '/api/v1/tickets/top/',
      WORKFLOW_STAGE: '/api/v1/tickets/workflow-stage/',
      CHANGE_STAGE: '/api/v1/tickets/change-stage/',
      CHANGE_STATUS: '/api/v1/tickets/change-status/',
      EDIT: '/api/v1/ticket/edit/',
      DUPLICATE: '/api/v1/ticket/duplicate/',
      SIGN: '/api/v1/ticket/sign/',
      UPLOAD: '/api/v1/ticket/upload/',
      BULK_DOWNLOAD: '/api/v1/ticket/downloads/',
      DOWNLOAD_PDF: '/api/v1/ticket/download/pdf/',
      DOWNLOAD: '/api/v1/ticket/download/',
      REQUEST_MAXIMUM_BORROWING: '/api/v1/ticket/request-maximum-borrowing/',
      MAXIMUM_BORROWING: '/api/v1/ticket/maximum-borrowing/',
      SIMPOLOGY_SEND_APPLICATION: '/api/v1/lodgement/simpology/send-application/',
      SIMPOLOGY_READ_APPLICATION: '/api/v1/lodgement/simpology/read-application/',
      APPLY_ONLINE_SEND_APPLICATION: '/api/v1/lodgement/apply-online/send-application/',
      APPLY_ONLINE_READ_APPLICATION: '/api/v1/lodgement/apply-online/read-application/',
      FLEX_CREATE_OPPORTUNITY: '/api/v1/integration/flex/create-opportunity',
      CONTACT_UPDATE_FACT_FIND: '/api/v1/ticket/contact-update-fact-find/',
      MOVE_TO_ANOTHER_WORKFLOW: '/api/v1/ticket/move-to-another-workflow/'
    },
    UI: {
      BOARD_HEADER_HEIGHT: 105,
      BOARD_DIFFERENCE_HEIGHT: 35.2,
      SINGLE_TICKET_HEIGHT_FULL: 94,
      SINGLE_TICKET_HEIGHT_BASIC_INFO_LABELS: 88,
      SINGLE_TICKET_HEIGHT_BASIC_LABELS: 68,
      SINGLE_TICKET_HEIGHT_BASIC_AVATARS: 61.2,
      SINGLE_TICKET_HEIGHT_BASIC_INFO: 55.2,
      SINGLE_TICKET_HEIGHT_BASIC: 35.2
    },
    FILTERS: {
      NAME: {
        path: 'name',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STAGE: {
        path: 'idStage',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      OWNER: {
        path: 'idOwner',
        type: { name: 'str' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      TEAM_MEMBER: {
        path: 'idTeamMembers',
        type: { name: 'arr' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      PARTNER: {
        path: 'idPartners',
        type: { name: 'arr' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      REFERRER: {
        path: 'idAccountsAsPartners',
        type: { name: 'arr' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      LABEL: {
        path: 'idLabels',
        type: { name: 'arr' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      CREATION_DATE: {
        path: 'timeStamp',
        type: { name: 'num' },
        operator: { name: 'btw' },
        operatorNot: false,
        values: []
      },
      EXPECTED_CLOSE_DATE: {
        path: 'values.onceOffDueDate',
        type: { name: 'num' },
        operator: { name: 'btw' },
        operatorNot: false,
        values: []
      },
      STATUS_DUE_AHEAD: {
        path: 'isDueAhead',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_DUE: {
        path: 'isDue',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_OVERDUE: {
        path: 'isOverdue',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_READY_FOR_VERIFICATION: {
        path: 'isReadyForVerification',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_VERIFIED: {
        path: 'isVerified',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_FROZEN: {
        path: 'isFrozen',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_ROTTEN: {
        path: 'isRotten',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_SUBMITTED: {
        path: 'isSubmitted',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_LODGED: {
        path: 'isLodged',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_CONDITIONALLY_APPROVED: {
        path: 'isConditionallyApproved',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_APPROVED: {
        path: 'isApproved',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_SETTLED: {
        path: 'isSettled',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_WON: {
        path: 'isWon',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_WITHDRAWN: {
        path: 'isWithDrawn',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_DECLINED: {
        path: 'isDeclined',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_LOST: {
        path: 'isLost',
        type: { name: 'bool' },
        operator: { name: 'eq' },
        operatorNot: false,
        values: []
      },
      STATUS_ACTIVE: {
        path: 'isActive',
        type: { name: 'bool' },
        operator: { name: 'ne' },
        operatorNot: false,
        values: []
      }
    },
    PROJECT_AVAILABLE_STATUSES: [
      { id: 0, title: 'Not started', icon: 'remove_circle', color: 'grey-500' },
      { id: 1, title: 'In progress', icon: 'play_circle_filled', color: 'orange-500' },
      { id: 2, title: 'Paused', icon: 'pause_circle_filled', color: 'red-500' },
      { id: 3, title: 'Completed', icon: 'check_circle', color: 'green-500' },
      { id: 4, title: 'Quality Check', icon: 'offline_pin', color: 'purple-500' },
      { id: 99, title: 'N/A', icon: 'lens', color: 'grey-300' }
    ],
    FACT_FIND: {
      NET_INCOME: {
        AU: {
          2014: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 80000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 80001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 17547,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.47,
              additionalTax: 54547,
              medicareLevy: 0.02
            }
          ],
          2015: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 80000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 80001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 17547,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.47,
              additionalTax: 54547,
              medicareLevy: 0.02
            }
          ],
          2016: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 87000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 87001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 19822,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.47,
              additionalTax: 54232,
              medicareLevy: 0.02
            }
          ],
          2017: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 87000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 87001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 19822,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.47,
              additionalTax: 54232,
              medicareLevy: 0.02
            }
          ],
          2018: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 90000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 90001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 20797,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.45,
              additionalTax: 54097,
              medicareLevy: 0.02
            }
          ],
          2019: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 90000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 90001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 20797,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.45,
              additionalTax: 54097,
              medicareLevy: 0.02
            }
          ],
          2020: [
            { incomeFrom: 0, incomeTo: 18200, tax: 0, additionalTax: 0, medicareLevy: 0.02 },
            {
              incomeFrom: 18201,
              incomeTo: 37000,
              tax: 0.19,
              additionalTax: 0,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 37001,
              incomeTo: 90000,
              tax: 0.325,
              additionalTax: 3572,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 90001,
              incomeTo: 180000,
              tax: 0.37,
              additionalTax: 20797,
              medicareLevy: 0.02
            },
            {
              incomeFrom: 180001,
              incomeTo: '',
              tax: 0.45,
              additionalTax: 54097,
              medicareLevy: 0.02
            }
          ]
        },
        NZ: {
          2017: [
            { incomeFrom: 0, incomeTo: 14000, tax: 0.105, additionalTax: 0, medicareLevy: 0 },
            {
              incomeFrom: 14001,
              incomeTo: 48000,
              tax: 0.175,
              additionalTax: 1470,
              medicareLevy: 0
            },
            {
              incomeFrom: 48001,
              incomeTo: 70000,
              tax: 0.3,
              additionalTax: 7420,
              medicareLevy: 0
            },
            {
              incomeFrom: 70001,
              incomeTo: 9999999,
              tax: 0.33,
              additionalTax: 14020,
              medicareLevy: 0
            }
          ],
          2018: [
            { incomeFrom: 0, incomeTo: 14000, tax: 0.105, additionalTax: 0, medicareLevy: 0 },
            {
              incomeFrom: 14001,
              incomeTo: 48000,
              tax: 0.175,
              additionalTax: 1470,
              medicareLevy: 0
            },
            {
              incomeFrom: 48001,
              incomeTo: 70000,
              tax: 0.3,
              additionalTax: 7420,
              medicareLevy: 0
            },
            {
              incomeFrom: 70001,
              incomeTo: 9999999,
              tax: 0.33,
              additionalTax: 14020,
              medicareLevy: 0
            }
          ],
          2019: [
            { incomeFrom: 0, incomeTo: 14000, tax: 0.105, additionalTax: 0, medicareLevy: 0 },
            {
              incomeFrom: 14001,
              incomeTo: 48000,
              tax: 0.175,
              additionalTax: 1470,
              medicareLevy: 0
            },
            {
              incomeFrom: 48001,
              incomeTo: 70000,
              tax: 0.3,
              additionalTax: 7420,
              medicareLevy: 0
            },
            {
              incomeFrom: 70001,
              incomeTo: 9999999,
              tax: 0.33,
              additionalTax: 14020,
              medicareLevy: 0
            }
          ],
          2020: [
            {
              incomeFrom: 0,
              incomeTo: 14000,
              tax: 0.105,
              additionalTax: 0,
              medicareLevy: 0.0139
            },
            {
              incomeFrom: 14001,
              incomeTo: 48000,
              tax: 0.175,
              additionalTax: 1470,
              medicareLevy: 0.0139
            },
            {
              incomeFrom: 48001,
              incomeTo: 70000,
              tax: 0.3,
              additionalTax: 7420,
              medicareLevy: 0.0139
            },
            {
              incomeFrom: 70001,
              incomeTo: 9999999,
              tax: 0.33,
              additionalTax: 14020,
              medicareLevy: 0.0139
            }
          ]
        }
      },
      ARCHIVE: {
        RATING: [
          { id: '', value: 'Select one', weight: 1 },
          { id: 1, value: 'Low', weight: 2 },
          { id: 2, value: 'Medium', weight: 3 },
          { id: 3, value: 'High', weight: 4 }
        ],
        HOW_IMPORTANT_OPTIONS: [
          { id: 1, value: 'Very important', weight: 1 },
          { id: 2, value: 'Somewhat important', weight: 2 },
          { id: 3, value: 'Not important', weight: 3 }
        ],
        INTEREST_ONLY_REASON: [
          {
            id: 1,
            value:
              'Wealth Creation - Cash flow for future investment (e.g. shares, investment property, super contributions)'
          },
          {
            id: 2,
            value: 'Temporary reduction in income (e.g. parental Leave, changing circumstances)'
          },
          {
            id: 3,
            value: 'Anticipated large expense item (e.g. education, renovation, furniture)'
          },
          { id: 4, value: 'Wealth Creation - Investment purpose' },
          {
            id: 5,
            value:
              'Wealth Creation - Intend to convert Owner Occupied property into investment property in the future'
          },
          { id: 6, value: 'Construction' },
          { id: 7, value: 'Recommendation provided by financial planner/accountant' },
          { id: 8, value: 'Bridging Finance' },
          { id: 9, value: 'Other (provide details)' }
        ]
      }
    },
    FIELDS: {
      BOARD: {
        list: [
          'id',
          'idOwner',
          'idWorkflow',
          'idStage',
          'idClients',
          'idPartners',
          'idTeamMembers',
          'uuid',
          'name',
          'idLabels',
          'tileColor',
          'values',
          'isInProgress',
          'isDueAhead',
          'isDue',
          'isOverdue',
          'isWon',
          'isLost',
          'isFrozen',
          'isRotten',
          'isSettled',
          'timeStamp',
          'isActive',
          'orderByField'
        ]
      },
      LIST: {
        list: [
          'id',
          'idOwner',
          'idWorkflow',
          'idStage',
          'idLabels',
          { owner: { user: ['avatar', 'firstName', 'lastName'] } },
          'clients',
          { teamMembers: { user: ['avatar', 'firstName', 'lastName'] } },
          { referrers: { user: ['avatar', 'firstName', 'lastName'] } },
          { organization: ['id', { organization: 'name' }] },
          { workflow: ['name', { stages: ['id', 'name'] }] },
          'name',
          { values: ['onceOff'] },
          'isInProgress',
          'isDueAhead',
          'isDue',
          'isOverdue',
          'isWon',
          'isLost',
          'isFrozen',
          'isRotten',
          'isSettled',
          'stageHistory',
          'timeStamp'
        ]
      },
      PROJECT: {
        list: [
          'id',
          'idOwner',
          'idWorkflow',
          'idStage',
          'name',
          'idLabels',
          'labels',
          'tileColor',
          'values',
          'projectHistory',
          'isInProgress',
          'isDueAhead',
          'isDue',
          'isOverdue',
          'isWon',
          'isLost',
          'isFrozen',
          'isRotten',
          'isSettled',
          'timeStamp',
          'isActive'
        ]
      },
      DROPDOWN: {
        list: [
          'id',
          'name',
          'isInProgress',
          'isDueAhead',
          'isDue',
          'isOverdue',
          'isWon',
          'isLost',
          'isFrozen',
          'isRotten',
          'timeStamp',
          'isActive'
        ]
      }
    },
    CACHE: {
      NAME: 'ticketsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
